import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "field", "toggle" ]
  static values = {
    boolean: Boolean,
    default: String,
    show: String,
    hide: String
  }


  connect() {
    if (this.hasFieldTarget) {

      this.fieldTarget.addEventListener('change', (e) => {
        this.onChangeValue(this.fieldTarget.value)
      })

      this.onChangeValue(this.fieldTarget.value)

    } else if (this.hasDefaultValue) {
      this.onChangeValue(this.defaultValue)
    }
  }

  onChangeValue(value) {
    this.value = value
    this.toggleTargets.forEach(t => this.toggle(t))
  }

  change(event) {
    this.onChangeValue(event.target.value)
  }

  toggle(t) {
    const showToggle =
      (this.booleanValue && this.fieldTarget.checked) ||  // field é um checkBox
      this.includeValue(this.showValue) ||               // show-value geral, definido no controller
      this.includeValue(t.dataset.showValue) ||          // show-value específico, definido no proprio toggleTarget
      this.notIncludeValue(this.hideValue) ||            // hide-value geral, definido no controller
      this.notIncludeValue(t.dataset.hideValue)          // hide-value específico, definido no proprio toggleTarget


    if (showToggle) {
      this.show(t)
    } else {
      this.hide(t)
    }
  }

  show(el) { el.style.display = 'block'; }
  hide(el) { el.style.display = 'none'; }

  includeValue(where) {
    return where && where.split('|').includes(this.value)
  }

  notIncludeValue(where) {
    return where && ! where.split('|').includes(this.value)
  }

}

// <div data-controller="toggler" data-toggler-boolean-value="true">
//
//   <%= f.input :contrato, as: :boolean, wrapper: :vertical_form,
//                          label: false,
//                          input_html: {
//                            data: { target: 'toggler.field' }
//                          } %>
//
//   <div class="row" data-target="toggler.toggle">
//     <%= f.input :numero_contrato %>
//   </div>
//
// </div>
